import { Dispatch } from "redux";
import {
    getUsersActions,
    getUsersDetailsActions,
    getUsersDate,
    resetUsersStateAction
} from "./UsersActions";
import API from "../../API";

export const getUsers = (params: Object) => async (dispatch: Dispatch) => {
  try {
    dispatch(getUsersActions.request());
    const usersData = await API.get('/users/list', { params });
    dispatch(getUsersActions.success({ data: usersData?.data, usersData: usersData?.data.data, page: usersData?.data.meta.current_page, isFetched: false, lastPage: usersData?.data.meta.last_page }));
  } catch (err) {
    console.log(err, 'errrr')
    dispatch(getUsersActions.fail(err));
  }
};

export const getUsersDetails = (id: number, activeType: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(getUsersDetailsActions.request());
    const usersDetails = await API.get(`users/${id}/${activeType}`);
    dispatch(getUsersDetailsActions.success({ usersDetails: usersDetails?.data, isFetched: false, }));
  } catch (err) {
    console.log(err, 'errrr')
    dispatch(getUsersDetailsActions.fail(err));
  }
};

export const getUsersStartAndEndDate = (data: any) => async (dispatch: Dispatch) => {
  try {
    dispatch(getUsersDate.request());
    dispatch(getUsersDate.success(data));
  } catch (err) {
    console.log(err, 'errrr')
    dispatch(getUsersDate.fail(err));
  }
};

export const resetUsersState = () => async (dispatch: Dispatch) => {
  try {
    dispatch(resetUsersStateAction.request());
    dispatch(resetUsersStateAction.success());
  } catch (err) {
    console.log(err, 'errrr')
    dispatch(resetUsersStateAction.fail(err));
  }
};
